/*
|
|               Zone
_______________________________________________
|
|    This class keep all fields for 
|    new zone of project.
|
*/

export class Zone {
    id                :any;
    active            :boolean = true;
    name              :string = '';
    notes             :string = '';
    projectID         :any;
    SquareFootage     :number;
    zoneData          :string = '';
}


// WEBPACK FOOTER //
// /root/anvel/angular/classes/Zone.ts